import React from 'react'
import '../middle content/Front.css'



export default function Front() {
    return (<>
        <section className='main-content'>
            <section className="home" id="home">
                <div className="home-content">
                    <div className="text">
                        <div className="text-one">Hello,</div>
                        <div className="text-two">I'm Avanish Chandra Pandey</div>
                        <div className='text-three'><span className="text_1">Full Stack Web Developer</span><span className="text_2">MERN Developer</span></div>
                        {/* <div class="text-three">Full Stack Web Developer & MERN Developer</div> */}
                        <div className="text-four">From Varanasi, India</div>
                    </div>
                    <a href="mailto:avanishpandey022@gmail.com?subject=Hire"><button className="btn btn-5"> Hire Me</button></a>
                </div>
            </section>
        </section>
        
        
        
        
</>
    )
}
